import React from 'react';
import Card from '../components/card';
import CardsContainer from '../containers/cards_container';

function OnboardSection({ cards, isCompleted }) {
  const Cards = () => (
    cards.map((props) => <Card key={props.step} {...props} isCompleted={isCompleted} />));

  let containerProps = { lg: 12, sm: 12, direction: 'column' };

  if (isCompleted) {
    containerProps = {
      justifyContent: 'flex-start', align: 'stretch', direction: 'row', alignItems: 'flex-start', style: { gap: '1.5em' },
    };
  }

  return (
    <CardsContainer {...containerProps}>
      <Cards />
    </CardsContainer>
  );
}

export default OnboardSection;
